export const ERROR_OFFER_ALREADY_ORDERED = 'OFFER_ALREADY_ORDERED';
export const ERROR_SERVICE_POINT_API = 'ERROR_SERVICE_POINT_API';
export const ERROR_SUBMIT_FORM_API = 'ERROR_SUBMIT_FORM_API';
export const ERROR_CONTACT_DATA_API = 'ERROR_CONTACT_DATA_API';
